/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    CodeAndLabelWithIndent,
    CodeAndLabelWithIndentFromJSON,
    CodeAndLabelWithIndentFromJSONTyped,
    CodeAndLabelWithIndentToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SMRuleFormConfiguration
 */
export interface SMRuleFormConfiguration {
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof SMRuleFormConfiguration
     */
    readonly dateTimeZones?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabelWithIndent>}
     * @memberof SMRuleFormConfiguration
     */
    readonly regions?: Array<CodeAndLabelWithIndent> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SMRuleFormConfiguration
     */
    readonly agencyGroups?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof SMRuleFormConfiguration
     */
    readonly salesJourneys?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof SMRuleFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof SMRuleFormConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof SMRuleFormConfiguration
     */
    readonly relevances?: Array<number> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SMRuleFormConfiguration
     */
    readonly suppliers?: Array<GuidIdAndLabel> | null;
}

export function SMRuleFormConfigurationFromJSON(json: any): SMRuleFormConfiguration {
    return SMRuleFormConfigurationFromJSONTyped(json, false);
}

export function SMRuleFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SMRuleFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateTimeZones': !exists(json, 'dateTimeZones') ? undefined : (json['dateTimeZones'] === null ? null : (json['dateTimeZones'] as Array<any>).map(CodeAndLabelFromJSON)),
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(CodeAndLabelWithIndentFromJSON)),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevances': !exists(json, 'relevances') ? undefined : json['relevances'],
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function SMRuleFormConfigurationToJSON(value?: SMRuleFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


